import React, { createContext, useContext, useEffect, useState } from 'react';
import { onNativeMessage, postToNative, isNativeApp } from './nativeBridge';
import MessageTypes from './messageTypes';

const BridgeContext = createContext(null);

/**
 * 네이티브에서 온 마지막 메시지를 보관해 화면들이 구독할 수 있게 한다.
 * 같은 타입의 메시지가 연속으로 와도 새 객체로 교체되므로 useEffect 가 매번 발화한다.
 */
export function BridgeProvider({ children }) {
    const [lastMessage, setLastMessage] = useState(null);

    useEffect(() => onNativeMessage((msg) => setLastMessage(msg)), []);

    const value = {
        post: postToNative,
        types: MessageTypes,
        lastMessage,
        isNativeApp: isNativeApp(),
    };

    return <BridgeContext.Provider value={value}>{children}</BridgeContext.Provider>;
}

export function useBridge() {
    const ctx = useContext(BridgeContext);
    if (!ctx) throw new Error('useBridge 는 BridgeProvider 안에서만 사용할 수 있습니다.');
    return ctx;
}
